import { useEffect, useState } from 'react';

import { PaginationInfoProps } from './PaginationInfo';

export function usePaginationInfo({
  currentPage,
  totalCount,
  pageSize,
}: PaginationInfoProps): string {
  const [paginationInfo, setPaginationInfo] = useState('');
  useEffect(() => {
    const start = 1 + pageSize * (currentPage - 1);
    const end = Math.min(pageSize * currentPage, totalCount);
    setPaginationInfo(`${start} - ${end} of ${totalCount}`);
  }, [currentPage, totalCount, pageSize]);

  return paginationInfo;
}
